<template>
  <div>

    <nav class="navbar customNavbar">
      <div class="navbar-brand">
        <a v-on:click="root()">
          <img class="logoClass" src="/static/logo.png">
        </a>
      </div>
      <div class="navbar-end">
        <a class="navbar-item customNavbarItem" v-on:click="root()">Inicio</a>
        <a class="navbar-item customNavbarItem" v-on:click="about()">Nosotros</a>
        <a class="navbar-item customNavbarItem" v-on:click="products()">Productos</a>
        <a class="navbar-item customNavbarItem" v-on:click="news()">Noticias</a>
        <a class="navbar-item customNavbarItem" v-on:click="contact()">Contacto</a>
        <a class="navbar-item customNavbarItemSelected" >Iniciar Sesión</a>
      </div>
    </nav>

    <section class="section">
      <div class="columns">
        <div class="column"></div>
        <div class="column is-4 ">
          <div class="field ">
            <label class="label">Email</label>
            <div class="control">
              <input class="input" type="text" v-model="email" required/>
            </div>
          </div>
          <div class="field">
            <label class="label">Contraseña</label>
            <div class="control">
              <input class="input" type="password" v-model="password" required/>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input class="button customButton" type="button" value="Registrarse" v-on:click="register()"/>
              <input class="button customButton is-pulled-right" type="button" value="Ingresar" v-on:click="login()"/>
            </div>
          </div>
        </div>
        <div class="column"></div>
      </div>
    </section>
    <FooterComponent/>
  </div>
</template>

<script>
import ApiClient from '@/api/ApiClient.js'
import FooterComponent from './FooterComponent'

export default {
  name: 'landing',
  components: {
    FooterComponent
  },
  data () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    root: function () {
      this.$router.push('/')
    },
    login: function () {
      ApiClient.login(this.email, this.password).then(response => {
        console.log(response.data.message)
        if (response.data.success) {
          localStorage.setItem('email', this.email)
          localStorage.setItem('token', response.data.token)
        } else {
          alert(response.data.message)
        }
        this.$router.push('/')
      }).catch(error => {
        ApiClient.onError(error)
      })
    },
    register: function () {
      this.$router.push('/register')
    },
    about: function () {
      window.scrollTo(0, 0)
      this.$router.push('/about')
    },
    products: function () {
      window.scrollTo(0, 0)
      this.$router.push('/products')
    },
    news: function () {
      window.scrollTo(0, 0)
      this.$router.push('/news')
    },
    contact: function () {
      window.scrollTo(0, 0)
      this.$router.push('/contact')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logoClass {
    height: 80px;
    width: 300px;
    margin-left: 20px;
    margin-top: 20px;
  }
  .imageStyle {
    margin-left: auto;
    margin-right: auto;
  }
  .infoClass {
    font-size: small;
    text-align: justify;
  }
  .infoTitle {
    text-align: left;
  }
  .footerInfo {
    margin-left: 100px;
    margin-right:100px;
    text-align: center;
    font-size: small;
  }
  .footerContact {
    text-align: left;
    font-size: small;
    margin-left: 100px;
    margin-right:100px;
    margin-top: 60px;
  }
  .footerLast {
    font-size: small;
    margin-bottom: 0px;
  }
</style>



// WEBPACK FOOTER //
// LoginComponent.vue?600c8af0